
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-primary/8 to-primary-dark/8">
      <div className="max-w-[1400px] mx-auto px-8 text-center">
        <h2 className="text-5xl font-bold text-primary-dark mb-6">
          Prêt à concrétiser vos projets ?
        </h2>
        <p className="text-xl text-gray-dark mb-10 max-w-2xl mx-auto leading-relaxed">
          Contactez-nous pour découvrir toutes les solutions disponibles dans votre agglomération
        </p>
        <Link
          to="/a-propos"
          className="inline-flex items-center gap-3 bg-primary text-white px-12 py-5 rounded-full text-lg font-semibold hover:bg-primary-dark transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          Nous contacter
          <i className="ri-arrow-right-line text-xl"></i>
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
